import React from 'react'
import { Icon } from './Icon'
import { useHubTheme } from './ThemeContext'
import { IconButton } from '@/components/atoms/IconButton'

export function TopBar({
  here,
  crumbs = [],
  refreshedAt,
  onSignOut,
}: {
  here: string
  crumbs?: string[]
  refreshedAt?: Date | null
  onSignOut?: () => void
}) {
  const { theme, toggle } = useHubTheme()
  const ago = useRefreshedAgo(refreshedAt)

  return (
    <div className="topbar">
      <div className="crumbs">
        <span className="pill admin">SUPER ADMIN</span>
        <span style={{ marginLeft: 4 }}>hub.usetenon.com</span>
        {crumbs.length > 0 && <span className="sep">/</span>}
        {crumbs.map((c, i) => (
          <React.Fragment key={i}>
            <span>{c}</span>
            <span className="sep">/</span>
          </React.Fragment>
        ))}
        {!crumbs.length && <span className="sep">/</span>}
        <span className="here">{here}</span>
      </div>
      <div className="grow" />
      {ago && (
        <span className="mono" style={{ fontSize: 11, color: 'var(--text-dim)' }}>
          refreshed {ago} ago
        </span>
      )}
      {/* Phase D §07.5 — top-right icon-button geometry parity with mobile + SidebarLayout */}
      <IconButton aria-label="Search" title="Search (⌘K)" size="md">
        <Icon name="search" />
      </IconButton>
      <IconButton aria-label="Notifications" title="Notifications" size="md">
        <Icon name="bell" />
      </IconButton>
      <IconButton
        aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
        title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
        onClick={toggle}
        size="md"
      >
        <Icon name={theme === 'dark' ? 'sun' : 'moon'} />
      </IconButton>
      {onSignOut && (
        <button className="btn ghost" type="button" onClick={onSignOut} title="Sign out">
          Sign out
        </button>
      )}
    </div>
  )
}

function useRefreshedAgo(at: Date | null | undefined) {
  const [, force] = React.useReducer((x: number) => x + 1, 0)
  React.useEffect(() => {
    if (!at) return
    const id = setInterval(force, 1_000)
    return () => clearInterval(id)
  }, [at])
  if (!at) return null
  const sec = Math.floor((Date.now() - at.getTime()) / 1000)
  if (sec < 60) return `${sec}s`
  const min = Math.floor(sec / 60)
  if (min < 60) return `${min}m`
  const hr = Math.floor(min / 60)
  return `${hr}h`
}
